export default [
    {
        "year": 1985,
        "question": "在原始社会里，弓箭的发明是生产工具的一项重大改进。根据考古发现，我国已知使用弓箭的是（ ）",
        "A": "北京人",
        "B": "山顶洞人",
        "C": "半坡氏族的人们",
        "D": "河姆渡氏族的人们",
        "answer": "C"
    },
    {
        "year": 1986,
        "question": "在原始社会里，弓箭的发明是生产工具的一项重大改进。根据考古发现，我国已知使用弓箭的是（ ）",
        "A": "北京人",
        "B": "山顶洞人",
        "C": "半坡氏族的人们",
        "D": "河姆渡氏族的人们",
        "answer": "C"
    },
    {
        "year": 1987,
        "question": "在原始社会里，弓箭的发明是生产工具的一项重大改进。根据考古发现，我国已知使用弓箭的是（ ）",
        "A": "北京人",
        "B": "山顶洞人",
        "C": "半坡氏族的人们",
        "D": "河姆渡氏族的人们",
        "answer": "C"
    },
    {
        "year": 1988,
        "question": "在原始社会里，弓箭的发明是生产工具的一项重大改进。根据考古发现，我国已知使用弓箭的是（ ）",
        "A": "北京人",
        "B": "山顶洞人",
        "C": "半坡氏族的人们",
        "D": "河姆渡氏族的人们",
        "answer": "C"
    },
    {
        "year": 1989,
        "question": "东汉桓帝时，大秦王安敦派使臣来华，大秦是指：（ ）",
        "A": "罗马帝国",
        "B": "罗马共和国",
        "C": "西罗马帝国",
        "D": "东罗马帝国",
        "answer": "A"
    },
    {
        "year": 1990,
        "question": "根据考古发现，我国用麻纺线织布的技术最早出现在（ ）",
        "A": "母系氏族公社繁荣时期",
        "B": "父系氏族公社时期",
        "C": "商朝",
        "D": "西周",
        "answer": "A"
    },
    {
        "year": 1991,
        "question": "下列各项中，表明齐桓公霸主地位得到正式承认的是（ ）",
        "A": "任用管仲为相进行改革",
        "B": "提出“尊王攘夷”的口号",
        "C": "周王派代表参加葵丘会盟",
        "D": "打败了不向周王纳贡的楚国",
        "answer": "C"
    },
    {
        "year": 1992,
        "question": "我国最早建立县制是在（ ）",
        "A": "春秋",
        "B": "战国",
        "C": "秦朝",
        "D": "汉朝",
        "answer": "B"
    },
    {
        "year": 1993,
        "question": "西晋时，西部和北部的少数民族陆续内迁，图中“川”部分代表哪一个少数民族分布的地区？（ ）",
        "A": "匈奴族",
        "B": "羌族",
        "C": "鲜卑族",
        "D": "氏族",
        "answer": "B"
    },
    {
        "year": 1994,
        "question": "在王安石新法推行过程中，最大阻力来自（ ）",
        "A": "大地主",
        "B": "中小地主",
        "C": "农民",
        "D": "皇室",
        "answer": "A"
    },
    {
        "year": 1995,
        "question": "下列战役中，战场地理位置最南的是（ ）",
        "A": "牧野之战",
        "B": "垓下之战",
        "C": "巨鹿之战",
        "D": "官渡之战",
        "answer": "B"
    },
    {
        "year": 1996,
        "question": "齐桓公多次召集诸侯会盟的主要目的是（ ）",
        "A": "提高齐国的政治地位",
        "B": "加强各国之间的交流",
        "C": "协调诸侯国间的争端",
        "D": "维护小国的经济利益",
        "answer": "A"
    },
    {
        "year": 1997,
        "question": "今桂林与长沙之间，历史上的水路交通最早开通于（ ）",
        "A": "战国",
        "B": "秦朝",
        "C": "西汉",
        "D": "隋朝",
        "answer": "B"
    },
    {
        "year": 1998,
        "question": "半坡人和河姆渡人生活的共同点是（ ）",
        "A": "普遍使用打制石器",
        "B": "制造陶器",
        "C": "种植栗、水稻",
        "D": "饲养猪、水牛",
        "answer": "B"
    },
    {
        "year": 1999,
        "question": "秦国成为战国七雄中实力最强的国家，主要原因是（ ）",
        "A": "实行商殃变法",
        "B": "更多使用铁制农具",
        "C": "牛耕得到推广",
        "D": "重视水利工程建设",
        "answer": "A"
    },
    {
        "year": 2000,
        "question": "下列对淝水之战中前秦失败原因的表述不正确的是（ ）",
        "A": "军队战斗力不强",
        "B": "军事指挥不当",
        "C": "攻打东晋不得人心",
        "D": "游牧民族不习水",
        "answer": "D"
    },
    {
        "year": 2001,
        "question": "传说中的尧舜时期大致处在（ ）",
        "A": "旧石器时代",
        "B": "新石器时代",
        "C": "青铜时代",
        "D": "铁器时代",
        "answer": "B"
    },
    {
        "year": 2002,
        "question": "我国境内原始人分布十分广阔，其中活动范围最为接近的是（ ）",
        "A": "元谋人、蓝田人",
        "B": "元谋人、北京人",
        "C": "北京人、山顶洞人",
        "D": "蓝田人、山顶洞人",
        "answer": "C"
    },
    {
        "year": 2003,
        "question": "我国古代用木炭冶炼生铁始于（ ）",
        "A": "西周",
        "B": "春秋时期",
        "C": "战国时期",
        "D": "西汉",
        "answer": "B"
    },
    {
        "year": 2004,
        "question": "就论证端午节是中国历史悠久的传统节日而言，下列哪方面的证据应当最有说服力?（ ）",
        "A": "古籍的记载",
        "B": "屈原的作品",
        "C": "政府的声明",
        "D": "学者的解释",
        "answer": "A"
    },
    {
        "year": 2005,
        "question": "元朝时，西藏正式成为中央政府管辖下的一个行政区，中央政府（ ）",
        "A": "在西藏设立行省",
        "B": "以宣政院为管理西藏地区的机构",
        "C": "在西藏设置卫所",
        "D": "设置驻藏大臣",
        "answer": "B"
    },
    {
        "year": 2006,
        "question": "下列历史事件发生在东汉时期的是（ ）",
        "A": "张骞出使西域",
        "B": "倭奴国奉贡朝贺",
        "C": "昭君远嫁呼韩邪单于",
        "D": "卫青、霍去病大败匈奴",
        "answer": "B"
    },
    {
        "year": 2007,
        "question": "孔孟学说主要讨论的是（ ）",
        "A": "人与人的关系",
        "B": "人与自然的关系",
        "C": "国与国的关系",
        "D": "夷夏关系",
        "answer": "A"
    },
    {
        "year": 2008,
        "question": "中国古代地名中的“阴”“阳”往往体现了该地与相邻山、水的关系。“阴”的方位是（ ）",
        "A": "山之南、水之北",
        "B": "山之南、水之南",
        "C": "山之北、水之北",
        "D": "山之北、水之南",
        "answer": "D"
    },
    {
        "year": 2009,
        "question": "北魏首创均田制，隋至唐初一直沿用。均田制下农业生产经营的主要形式是（ ）",
        "A": "众人集体生产",
        "B": "田庄规模生产",
        "C": "个体农户耕作",
        "D": "官府募民耕作",
        "answer": "C"
    },
    {
        "year": 2010,
        "question": "王安石提出“形者，有生之本”，与之相对立的观点是（ ）",
        "A": "“心外无物”",
        "B": "“天地为万物之本”",
        "C": "“夫形于天地之间者，物也”",
        "D": "“舍天地则无以为道”",
        "answer": "A"
    },
    {
        "year": 2011,
        "question": "1964年到1982年期间，在苏联“完善”社会主义的提法逐渐取代“改革”的提法，随之出现的是（ ）",
        "A": "社会经济发展丧失活力",
        "B": "破坏法治现象得到纠正",
        "C": "社会主义自治制度确立",
        "D": "放松对东欧国家的控制",
        "answer": "A"
    },
    {
        "year": 2012,
        "question": "秦汉而后，官府下层文职人员俗称“刀笔吏”，这一称谓起因于秦汉时期此类人员的（ ）",
        "A": "工作器具",
        "B": "工作内容",
        "C": "工作职责",
        "D": "工作性质",
        "answer": "A"
    },
    {
        "year": 2013,
        "question": "1688年，英国议会迎立荷兰之争威廉为国王，并拥立他的妻子玛丽(詹姆士二世的女儿)为女王，目的是（ ）",
        "A": "加强英国与荷兰的友好关系",
        "B": "否定王位世袭男性优先原则",
        "C": "通过双王相互牵制防止独裁",
        "D": "为光荣革命披上合法的外衣",
        "answer": "D"
    },
    {
        "year": 2014,
        "question": "人性是先秦以来一直讨论的问题。基于对人性的新认识，宋明理学家主张“存天理，灭人欲”，他们认为人性（ ）",
        "A": "本质是善",
        "B": "本质为恶",
        "C": "非善非恶",
        "D": "本善习远",
        "answer": "D"
    },
    {
        "year": 2015,
        "question": "1935年8月，美国国会通过法案，其中规定凡年满65岁的退休人员，根据原工资水平每月可获得一定数额的养老金。与该规定属于同一法案的是（ ）",
        "A": "制订公平经营章程",
        "B": "建立失业保险制度",
        "C": "提供农副产品补贴",
        "D": "规定最低工资水平",
        "answer": "B"
    },
    {
        "year": 2016,
        "question": "19世纪中期以后，中国市场上的洋货日益增多，火柴、洋布等用品“虽穷乡僻壤，求之于市，必有所供”。这种状况表明（ ）",
        "A": "中国关税主权开始丧失",
        "B": "商品经济基本取代自然经济",
        "C": "民众生活与世界市场联系日趋密切",
        "D": "中国市场由被动开放转为主动开放",
        "answer": "C"
    },
    {
        "year": 2017,
        "question": "周灭商之后，推行分封制，如封武王弟康叔于卫，都朝歌（今河南淇县）封周公长子伯禽于鲁，都奄（今山东曲阜）；封召公爽于燕，都（今北京）。分封（ ）",
        "A": "推动了文化的交流与文化认同",
        "B": "强化了君主专制权力",
        "C": "实现了王室对地方的直接控制",
        "D": "确立了贵族世袭特权",
        "answer": "D"
    },
    {
        "year": 2018,
        "question": "1920年，一些人撰文批评工读互助等社会改良活动，认为“零零碎碎的救济”“无补大局”，主张对社会进行“根本改造”，走进工厂，深入工人群众。这表明当时（ ）",
        "A": "民主与科学观念广泛传播",
        "B": "实业救国运动如火如荼",
        "C": "马克思主义影响日益增强",
        "D": "批判传统礼教成为共识",
        "answer": "C"
    },
    {
        "year": 2019,
        "question": "据学者考订，商朝产生了17代30位王，多为兄终弟及；而西周产生了11代12位王。这反映出（  ）",
        "A": "禅让制度的长期影响",
        "B": "王位继承方式的变化",
        "C": "君主寿命的时代差异",
        "D": "血缘纽带关系的弱化",
        "answer": "B"
    },
    {
        "year": 2020,
        "question": "唐代书法家张旭曾说：“始吾闻公主与担夫争路，而得笔法之意。后见公孙氏舞剑器，而得其神。”据此可知，张旭书法呈现出（ ）",
        "A": "书写结构的严整性",
        "B": "书写气象的灵动性",
        "C": "书写笔画繁杂性",
        "D": "书写技法的内敛性",
        "answer": "B"
    }
]